import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openLangSelector, openMenuMobile } from "../redux";

export const useGoPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const goPage = (route) => {
        const currentPath = window.location.pathname;
        const newPath = `/${route}`;

        const getMainSection = (path) => {
            const segments = path.split('/').filter(Boolean);
            return segments[0] || '';
        };

        const currentSection = getMainSection(currentPath);
        const newSection = getMainSection(newPath);

        dispatch(openLangSelector(false));
        dispatch(openMenuMobile(false));
        navigate(newPath);

        if (currentSection !== 'illustrations' && newSection !== 'illustrations') {
            window.scrollTo(0, 0);
        }
    };
    return goPage;
};